import { render } from "./updatemobile.vue?vue&type=template&id=12252771&scoped=true"
import script from "./updatemobile.vue?vue&type=script&lang=js"
export * from "./updatemobile.vue?vue&type=script&lang=js"

import "./updatemobile.vue?vue&type=style&index=0&id=12252771&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12252771"]])

export default __exports__